// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 8792 ? "main" : chunkId) + "." + {"4457":"82ab5abcd921ece38d97","8792":"2493f3f5391fffece85e"}[chunkId] + ".css";
};